import React, { useMemo } from "react";

import {
  DescriptionSchemaValidator,
  IDescriptionElement,
  IStaticElementUnion,
} from "@graffer-inc/form-schema";
import { ErrorMessage } from "../helper";
import { StaticElementCommonPropertiesEditor } from "./static-element-common-properties-editor";
import {
  grafferSchemasSuportTagNames,
  markdownHelpLink,
} from "../../../../../../../utils/markdown/constants";
import { ExternalLink, MarkdownEditor } from "@graffer-inc/console-design-kit";

type Props = {
  element: IDescriptionElement;
  onElementUpdate: (arg: IStaticElementUnion) => void;
};

export const DescriptionElementEditor: React.FC<Props> = ({
  element,
  onElementUpdate,
}) => {
  const descriptionId = `${element.id}-description`;

  const schemaValidator = useMemo(() => {
    return new DescriptionSchemaValidator(element, "warn");
  }, [element]);

  return (
    <>
      <StaticElementCommonPropertiesEditor element={element} />
      <div className="field">
        <div className="label is-flex is-justify-content-space-between is-align-items-baseline mb-0">
          <label className="mb-2" htmlFor={descriptionId}>
            説明文
          </label>
          {element.isMarkdown && (
            <ExternalLink
              anchor={(props) => (
                <a
                  {...props}
                  href={markdownHelpLink}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  {props.children}
                </a>
              )}
            >
              入力方法やサンプルはこちら
            </ExternalLink>
          )}
        </div>
        <div className="control">
          {element.isMarkdown ? (
            <MarkdownEditor
              value={element.text}
              layout="standalone"
              allowedTagNames={grafferSchemasSuportTagNames}
              editAreaOptions={{
                attributes: {
                  id: descriptionId,
                  placeholder: "未設定",
                  rows: 5,
                },
              }}
              onChange={(text) => {
                onElementUpdate({
                  ...element,
                  text,
                });
              }}
            />
          ) : (
            <textarea
              id={descriptionId}
              className="textarea"
              placeholder="未設定"
              value={element.text}
              onChange={(e) => {
                onElementUpdate({
                  ...element,
                  text: e.target.value,
                });
              }}
            />
          )}
        </div>
        <ErrorMessage msg={schemaValidator.text()} />
      </div>
    </>
  );
};
